

export default function ViewContent(props) {

  return (
    <>
    <div className="container d-none d-md-block">
      <div className="row">
        <div className="col-lg-1 d-none d-lg-block"></div>
        <div className="col col-lg-10">{props.content}</div>
        <div className="col-lg-1 d-none d-lg-block"></div>
      </div>
    </div>

    <div className="container d-md-none px-3">
      <div className="row">
        <div className="col">{props.content}</div>
      </div>
    </div>

    </>
  )
}